<template lang="pug">
.layout
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card(min-height="80vh")
      v-card-title.px-5
        v-row(no-gutters)
          v-col(cols="10" offset="1")
            .text-xl.font-bold.text-center {{ $t('reload_credit') }}
          v-col(cols="1" align="right")
            v-btn(icon  @click="showModal = !showModal" small color="primary")
              v-icon mdi-close
      v-divider
      v-card-text.pa-6
        // Rates
        .text-lg.font-semibold.mb-4.neutral700--text {{ $t('rates') }}
        .d-flex.align-center.mb-6.neutral700--text
          // SMS
          .mr-4
            .text-sm.font-semibold SMS
            .text-sm RM0.15/sms
          // WhatsApp
          .mr-4
            .text-sm.font-semibold WhatsApp
            .text-sm RM0.05/WhatsApp
          // Email
          div
            .text-sm.font-semibold {{ $t('email') }}
            .text-sm RM0.05/
              span.lowercase {{ $t('email') }}

        v-form(ref="form")
          div.text-lg.font-semibold.neutral700--text {{ $t('choose_your_reload_amount') }}
          div.d-flex.align-center.mt-2.mb-4
            template(v-for="(amount,index) in reloadAmountList")
              v-btn.button-AA-medium.neutral700--text.defaultBtn.mr-2.round-lg(:class="{'selectedBtn': reloadAmount === amount}" outlined @click="selectAmount(amount), reloadAmount = amount" :key="`ta-${index}`") {{ amount }}.00
              //v-btn.button-AA-medium.defaultBtn.neutral700--text(:class="{ 'firstBtn' : index === 0, 'lastBtn': index === reloadAmountList.length-1, 'selectedBtn': reloadAmount == amount}" outlined @click="selectAmount(amount), reloadAmount = amount" :key="`ta-${index}`") {{ amount }}.00
          //.amount.mt-3
          //  v-text-field.text-sm.round-xl(v-model="reloadAmount" :placeholder="$t('enter_minimum_price')" outlined dense height="48" type="number" min=5 :rules="rules.min" :prefix="$currency.symbol" hide-details="auto")
          .payment-method.mt-4
            .selection(v-if="showCardCreditOption")
              div.text-sm.font-semibold.neutral500--text.text-uppercase {{ $t('payment_method') }}
              y-select.mt-2(v-model="form.paymentMethod" :placeholder="$t('select_payment_method')" :items="paymentMethods" item-text="name" item-value="id" :rules="rules.is_selected")
              //- v-select.mt-2(v-model="form.paymentMethod" :placeholder="$t('select_payment_method')" :items="paymentMethods" item-text="name" item-value="id" background-color="basic200" height="40" outlined dense append-icon="mdi-chevron-down" :rules="rules.is_selected")
                template(v-slot:item="{ item }")
                  v-list-item-content
                    v-list-item-title {{ item.name }}

            v-card.mt-6(v-if="form.paymentMethod" flat)
              card-list.mt-4(v-if="form.paymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="form.paymentMethod === 'fpx'" )
                div.subtitle.mb-3 {{ $t('choose_bank_for_payment') }}
                v-card.mb-12
                  FPXPicker(v-model="form.fpxBankCode")
      v-divider
      v-card-actions.pb-4.pt-3.px-6
        div(style="width: 100%;")
          .total(v-if="form.paymentAmount")
            div.d-flex.align-center
              div.text-sm.neutral500--text {{ $t('reload_amount') }}
              v-spacer
              div.text-sm.font-medium.neutral500--text {{ form.paymentAmount | displayPrice }}
            div.d-flex.align-center.mt-1
              div.text-sm.neutral500--text {{ $t('reload_charge') }}
              v-spacer
              div.text-sm.font-medium.neutral500--text {{ 100 | displayPrice }}
            div.d-flex.align-center
              div.text-lg.font-semibold.neutral700--text {{ $t('total_payment') }}
              v-spacer
              div.text-lg.font-semibold.neutral700--text {{ form.paymentAmount + 100 | displayPrice }}
          div.d-flex.align-center.mt-4
            y-button.mr-4(:label="$t('cancel')" underline size="sm" button-class="px-0" @click="showModal = !showModal")
            v-spacer
            y-button(v-if="form.paymentMethod == 'card'" :label="$t('pay_now')" size="sm" @click="clickPayNow" :disabled="!form.card" :loading="isLoading")
            y-button(v-else-if="form.paymentMethod == 'fpx'" :label="$t('pay_now')" size="sm" @click="clickPayNow" :disabled="!form.fpxBankCode" :loading="isLoading")
            y-button(v-else :label="$t('pay_now')" size="sm" @click="clickPayNow")

  .modals
    y-dialog(v-model="openBillWindowDialog" width="400px" persistent)
      v-card
        v-card-title {{ $t('please_pay_to_proceed') }}
        v-card-text.px-6
          div {{ $t('you_will_be_redirected') }}
        v-card-actions
          v-spacer
          v-btn(text @click="openBillWindowDialog = false")
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click='openPaymentPage()')
            .button-AA-small.basic100--text {{ $t('pay_now') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'

export default {
  name: "ReloadCreditDialog",
  components: { CardList, FPXPicker },
  props: ['open', 'refreshPage'],
  data: () => ({
    reloadAmountList: [100,250,500],
    reloadAmount: 0,
    form: {
      paymentAmount: 0,
      paymentMethod: 'fpx',
      card: null,
      fpxBankCode: null
    },
    paymentMethods: [
      { name: 'Credit or debit card', id: 'card'},
      { name: 'Online banking', id: 'fpx'}
    ],
    isLoading: false,
    billUrl: '',
    openBillWindowDialog: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      min: [v => v >= 50 || 'Minimum reload amount is RM 50.00']
    },
  }),
  mounted(){
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    showCardCreditOption () {
      if (window.location.hostname.includes("localhost") || window.location.hostname.includes("arbatravel-test")) {
        return true
      } 
      return false
    }
  },
  watch: {
    reloadAmount (val) {
      this.form.paymentAmount = parseInt((parseFloat(val)).toFixed(this.$currency.exponent).replace('.', ''))
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    btnClass(index,length){
      if (index==0) {
        return 'firstBtn'
      } else if (index==length) {
        return 'lastBtn'
      }
    },
    selectAmount(amount){
      this.reloadAmount = amount
    },
    clickPayNow () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = {
        company: this.company.id,
        amount: this.form.paymentAmount
      }
      if (this.form.paymentMethod === 'card') {
        data.card = this.form.card
      } else if (this.form.paymentMethod === 'fpx') {
        data.bank_code = this.form.fpxBankCode
      }
      this.$axios.post('/billing/prepaid_credit_reloads/topup_request/', data)
        .then(resp => {
          if (this.form.paymentMethod === 'card') {
            this.showMessage(['success', this.$t('success_message.reload_successful')])
            this.fetchCompany()
            this.showModal = false
            if (this.refreshPage) {
              window.location.reload()
            }
          } else if (this.form.paymentMethod === 'fpx') {
            this.billUrl = resp.data.bill_url
            if (this.billUrl) {
              window.open(this.billUrl)
              this.showModal = false
              if (this.refreshPage) {
                window.location.reload()
              }
            } else {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            }
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        }).catch(() => {})
    },
    openPaymentPage () {
      window.open(this.billUrl, '_blank')
    }
  }
};
</script>

<style scoped>
.defaultBtn {
  border: 1px solid var(--v-primary300) !important;
  box-shadow: none;
}
.selectedBtn {
  background-color: var(--v-primary500);
  border-color: var(--v-primary500);
  color: white !important;
}
.firstBtn {
  border-radius: 4px 0 0 4px;
}
.lastBtn {
  border-radius: 0 4px 4px 0;
}

div >>> .v-btn--active {
  background-color: var(--v-primary500);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "reload_credit": "Reload Credit",
    "select_reload_amount": "select reload amount",
    "choose_bank_for_payment": "Choose bank for payment",
    "reload_amount": "Reload Amount",
    "reload_charge": "Reload Charge",
    "total_payment": "Total Payment",
    "please_pay_to_proceed": "Please pay to proceed",
    "you_will_be_redirected": "You will be redirected to a payment page after clicking 'Pay Now' button. Please close that page after payment is completed.",
    "enter_minimum_price": "Enter minimum RM 5.00",
    "select_payment_method": "Select payment method"
  },
  "id": {
  }
}
</i18n>
